import { importClass } from "../../utilities/dynamicImportsUtility";

export default class DoCta extends HTMLElement {
  private readonly initializedAttribute = "is-initialized";

  private _config = {};

  public constructor() {
    super();
  }

  public connectedCallback() {
    console.debug("DoCta registered");
    if (document.readyState === "loading") {
      window.addEventListener("DOMContentLoaded", () => this.initialize());
    } else {
      this.initialize();
    }
  }

  private async initialize() {
    let config: { [key: string]: any } = {};
    const configElement = this.querySelector(
      "script[type='application/json'][role='config']"
    );

    if (configElement) {
      config = JSON.parse(configElement.innerHTML);
      configElement.remove();
    }

    for (let i = 0; i < this.attributes.length; i++) {
      const attr = this.attributes[i];
      config[attr.name] = parseType(attr.value);
    }

    this.setAttribute(this.initializedAttribute, "true");

    this._config = config;

    importClass(
      () =>
        import(/* webpackChunkName: "doCtaController" */ "./doCtaController"),
      true,
      [this, this._config]
    );
  }
}

function parseType(value: string) {
  try {
    return JSON.parse(value);
  } catch (err) {
    return value;
  }
}

customElements.define("do-cta", DoCta);
